export default __webpack_public_path__ + "static/media/device-id.a4a202a8.svg";